import { createSlice, type PayloadAction } from '@ufc/core'

import type { IntakeResponse } from '../domain/types/api.types'

export interface TripPlanningIntakeState {
  result: IntakeResponse | null
  loading: boolean
  error: string | null
}

const initialState: TripPlanningIntakeState = { result: null, loading: false, error: null }

const slice = createSlice({
  name: 'tripPlanningIntake',
  initialState,
  reducers: {
    load: (state, _action: PayloadAction<string>) => {
      state.loading = true
      state.error = null
    },
    loadSuccess: (state, action: PayloadAction<IntakeResponse>) => {
      state.result = action.payload
      state.loading = false
    },
    loadFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const tripPlanningIntakeActions = slice.actions
export const tripPlanningIntakeReducer = slice.reducer
